import {APIPromise, easasAxios, requestPromiseTypeWrapper} from "../services/HttpService";
import {AxiosInstance} from 'axios'
import {BaseDatasetDTO, DatasetCategoryDTO, DatasetInfo} from "./apiModels";

const API_SCOPE = "/datasets";

const promise = requestPromiseTypeWrapper;

class DatasetsApiDefinition {
    private httpClient: AxiosInstance;

    constructor() {
        console.log("DatasetsApi obj created!");
        this.httpClient = easasAxios;
    }

    async getDatasetCategories(): APIPromise<DatasetCategoryDTO[]> {
        try {
            const {data} = await this.httpClient.get(`${API_SCOPE}/categories`);
            const obj = data.map((it: Partial<DatasetCategoryDTO>) => new DatasetCategoryDTO(it))
            return {data: obj}
        } catch (error: any) {
            return {error: error.response?.data};
        }
    }

    async getBaseDataset(identifier: string | undefined | null): APIPromise<BaseDatasetDTO | null> {
        if (!identifier) {
            return {data: null};
        }

        try {
            const {data} = await this.httpClient.get(`${API_SCOPE}/${identifier}`);
            const obj = new BaseDatasetDTO(data)
            return {data: obj}
        } catch (error: any) {
            return {error: error.response?.data};
        }
    }

  async queryDatasets(query?: string | null, limit?: number | null, identifiers?: string[] | null): APIPromise<DatasetInfo[]> {
    const params = {
      query: query || null,
      limit: limit,
      identifiers: identifiers?.join(",") || undefined,
    };

        try {
            const {data} = await this.httpClient.get(`${API_SCOPE}/search`, {params: params});
            const obj = data.map((it: any) => new DatasetInfo(it))
            return {data: obj}
        } catch (error: any) {
            return {error: error.response?.data};
        }
    }

    async getDatasetInfo(identifier: string | null): APIPromise<DatasetInfo> {
        if(!identifier) return {data: undefined};

        return promise(this.httpClient.get(`${API_SCOPE}/search`, {params: {identifiers: identifier}}), (data: any) => {
            return new DatasetInfo(data[0]);
        });
    }

    async getPaginatedDatasetsList(query?: string | null, page?: number | null, size?: number | null): APIPromise<DatasetInfo[]> {
        return promise(this.httpClient.get(`${API_SCOPE}/infos`,
            { params: { query: query, page: page, size: size } }),
            (data: any) => data.map((d: Partial<DatasetInfo>) => new DatasetInfo(d)));
    }

    async getDatasetsCount(): APIPromise<number> {
        return promise(this.httpClient.get(`${API_SCOPE}/count`));
    }
}

export const DatasetsApi = new DatasetsApiDefinition();
